var React = require('react');

function KeyboardArrowDownBlack24dp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z","key":1})]);
}

KeyboardArrowDownBlack24dp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = KeyboardArrowDownBlack24dp;

KeyboardArrowDownBlack24dp.default = KeyboardArrowDownBlack24dp;
